import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { env } from '@/lib/env';
import styles from './BrandMallFooter.module.scss';

const cx = classNames.bind(styles);

const BrandmallFooter = () => {
  const [didMount, setDidMount] = useState(false);
  const [location, setLocation] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setDidMount(true);
      setLocation(window.location.href);
    }, 500);
  }, []);

  const footerData = {
    clkCode: 'fot',
    key: 'package_tour',
    name: '네이버 티켓·패키지',
    customerCenter: '21991',
    desc: '네이버 티켓·패키지 여행은 여행 상품 판매사에서 제공한 여행 상품의 정보를 비교, 중개하는 서비스입니다. 네이버(주)는 통신판매의 당사자가 아니며 상품 검색 결과, 구매 및 환불 등에 관련한 의무와 책임은 각 판매자에게 있습니다.',
  };

  const loginLink = `https://nid.naver.com/nidlogin.login?svctype=262144&url=${location}`;
  const logoutLink = `https://nid.naver.com/nidlogin.logout?svctype=262144&returl=${location}`;

  return (
    <>
      <footer role="contentinfo" className={cx('BrandMallFooter')}>
        <nav>
          <a className={cx('anchor')} href={env('FOOTER_LINK_PRIVACY_POLICY')} target="_blank" rel="noreferrer">
            <strong>개인정보처리방침</strong>
          </a>
          <a className={cx('anchor')} href={env('FOOTER_LINK_SERVICE_TERMS')} target="_blank" rel="noreferrer">
            이용약관
          </a>
          <a
            className={cx('anchor')}
            data-media="desktop"
            href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=2208162517"
            target="_blank"
            rel="noreferrer"
          >
            사업자정보 공개
          </a>
          <a className={cx('anchor')} href={env('FOOTER_LINK_SUPPORT')} target="_blank" rel="noreferrer">
            고객센터
          </a>
          <span data-break-point />
          {didMount && document.cookie.split(';').filter((item) => item.includes('NID_SES=')).length ? (
            <a className={cx('anchor')} href={logoutLink}>
              로그아웃
            </a>
          ) : (
            <a className={cx('anchor')} href={loginLink}>
              로그인
            </a>
          )}
          <a className={cx('anchor')} href="https://m.naver.com/services.html">
            전체서비스
          </a>
        </nav>
        <details className={cx('business')} data-media="mobile">
          <summary>네이버㈜ 사업자 정보</summary>
          <address>
            <dl>
              <div>
                <dt>대표이사</dt>
                <dd>최수연</dd>
              </div>
              <div>
                <dt>주소</dt>
                <dd>
                  경기도 성남시 분당구 정자일로 95
                  <br />
                  NAVER 1784, 13561
                </dd>
              </div>
              <div>
                <dt>전화</dt>
                <dd>1588-3819</dd>
              </div>
              <div>
                <dt>이메일</dt>
                <dd>helpcustomer@naver.com</dd>
              </div>
              <div>
                <dt>사업자 등록번호</dt>
                <dd>220-81-62517</dd>
              </div>
              <div>
                <dt>통신판매번호</dt>
                <dd>2006-경기성남-0692</dd>
              </div>
              <div>
                <dt>호스팅 서비스 제공</dt>
                <dd>NAVER Cloud</dd>
              </div>
            </dl>
          </address>
        </details>
        <div className={cx('business')} data-media="desktop">
          <dl>
            <dt>사업자 등록번호&nbsp;</dt>
            <dd>220-81-62517</dd>
            <dt>통신판매번호&nbsp;</dt>
            <dd>2006-경기성남-0692</dd>
            <dt>대표이사&nbsp;</dt>
            <dd>최수연</dd>
            <dt>전화번호&nbsp;</dt>
            <dd>1588-3819</dd>
            <dt>이메일&nbsp;</dt>
            <dd>helpcustomer@naver.com</dd>
          </dl>
          <dl>
            <dt>주소&nbsp;</dt>
            <dd>경기도 성남시 분당구 정자일로 95 NAVER 1784, 13561</dd>
            <dt>호스팅 서비스 제공&nbsp;</dt>
            <dd>NAVER Cloud</dd>
          </dl>
        </div>
        <p className={cx('limitation')}>{footerData.desc}</p>
        <i className={cx('naver')}>
          <span>NAVER</span>
        </i>
      </footer>
    </>
  );
};

export default BrandmallFooter;
